<template>
	<div>
		<el-form :model="user" :rules="rules" ref="editUserForm" label-width="100px" size="medium"
						 :status-icon="true" label-suffix=" : ">
			<el-form-item label="姓名" prop="displayName" >
				<el-input v-model="user.displayName"></el-input>
			</el-form-item>
			<el-form-item label="手机号码" prop="phone" >
				<el-input v-model="user.phone"></el-input>
			</el-form-item>
			<el-form-item label="Email" prop="email">
				<el-input v-model="user.email" placeholder="请输入Email"></el-input>
			</el-form-item>
			<el-form-item label="角色" prop="type">
				<el-radio v-model="user.type" :label="0">普通用户</el-radio>
				<el-radio v-model="user.type" :label="1">管理员</el-radio>
			</el-form-item>
		</el-form>
		<div style="text-align: right;">
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import axios from "axios"
	import config from "../../../config/global.js";

	var adminUpdateUserUrl =  config.host + "backend/user/managerupdateuser.json";

    export default {
        name: "edit-customer-panel",
			data:function () {
				var validatorPhone = function (rule, phone, callback) {
					if(phone == null || phone == ""){
						callback(new Error("手机号码不能为空!"));
					}else if(!(/^1[3456789]\d{9}$/.test(phone))){
						callback(new Error("手机号码填写有误!"));
					}else{
						callback();
					}
				};
				return {
					operating:false,
					rules: {
						name: [
							{ required: true, message: '请输入客户姓名', trigger: 'blur' },
						],
						phone: [
							{ required: true, validator:validatorPhone },
						],
						sex: [
							{ required: true, message: '请选择性别', trigger: 'blur' }
						],
						email:[
							{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
						]
					},
				}
			},
			props:{
				user:{}
			},
			methods:{
				submit(){
					this.$refs.editUserForm.validate((valid) => {
						if (valid) {
							this.operating = true;
							var userData = {};
							userData.displayname = this.user.displayName;
							userData.phone = this.user.phone;
							userData.id = this.user.id;
							userData.email = this.user.email;
							userData.type = this.user.type;
							axios({
								method: 'post',
								url:adminUpdateUserUrl,
								data:userData
							}).then((response)=>{
								var defaultResult = this.responseDefaultHandle(response);
								if(defaultResult == false )
									return;
								if(response.data.result == 1){
									this.$message({
										message: '更新成功',
										type: 'success'
									});
									this.$emit('updatesuccess');
								}else{
									this.$alert(response.data.emsg, '更新失败', {
										confirmButtonText: '确定'
									});
								}
								this.operating = false;
							}).catch((error)=>{
								this.operating = false;
								this.$alert(error.response.statusText, '更新失败', {
									confirmButtonText: '确定'
								});
							})
						} else {
							return false;
						}
					});
				}
			}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/user/EditUserPanel.vue